module.exports = __webpack_public_path__ + "img/img4.3e0b2e4f.jpg";